import { Cloud, Sun, CloudRain, CloudSnow } from "lucide-react";
import { API } from "./adventureApi";

export const weatherIcon = (code, isDay = 1) => {
  if (code === 0 || code === 1) return isDay ? Sun : Cloud;
  if ([2, 3, 45, 48].includes(code)) return Cloud;
  if (code >= 71 && code <= 86) return CloudSnow;
  if (code >= 51) return CloudRain;
  return Cloud;
};

const cache = {};
export async function fetchWeather(lat, lng) {
  const key = `${lat.toFixed(2)},${lng.toFixed(2)}`;
  if (cache[key]) return cache[key];
  const p = fetch(`${API}/weather?lat=${lat}&lng=${lng}`)
    .then((r) => (r.ok ? r.json() : null))
    .catch(() => null);
  cache[key] = p;
  return p;
}
